module.exports = __webpack_public_path__ + "img/notification-check.06f06949.svg";